import { MapPin } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { CITIES } from "@/constants/site";

export default function MapSection({ light = false }) {
  return (
    <section data-testid="map-section" className={`${light ? "bg-[#161514]" : "bg-[#EFECE6]"} py-24 sm:py-32`}>
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <Overline light={light}>Zona Servita</Overline>
          <h2
            className={`mt-4 max-w-xl font-serif text-2xl font-semibold tracking-tight sm:text-3xl lg:text-4xl ${
              light ? "text-[#FAF8F5]" : "text-[#1A1918]"
            }`}
          >
            Operiamo in tutte le Marche, con il cuore a Osimo.
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-8 lg:grid-cols-5">
          <Reveal className="lg:col-span-3" delay={0.1}>
            <div className="overflow-hidden rounded-2xl border border-[#B88E4C]/25 shadow-2xl">
              <iframe
                data-testid="service-area-map"
                title="Mappa della zona servita — Osimo e Marche"
                src="https://www.openstreetmap.org/export/embed.html?bbox=12.9000%2C43.1500%2C14.1000%2C43.8000&layer=mapnik&marker=43.4847%2C13.4877"
                className="h-[380px] w-full grayscale-[35%] sepia-[15%] sm:h-[440px]"
                loading="lazy"
              />
            </div>
          </Reveal>

          <Reveal className="lg:col-span-2" delay={0.2}>
            <div
              className={`flex h-full flex-col justify-between rounded-2xl border p-8 ${
                light ? "border-[#FAF8F5]/15 bg-[#22201E]" : "border-[#1A1918]/10 bg-[#F7F5F0]"
              }`}
            >
              <div>
                <p className={`font-mono text-xs uppercase tracking-[0.25em] ${light ? "text-[#B88E4C]" : "text-[#6E6A64]"}`}>
                  Città coperte
                </p>
                <ul data-testid="cities-list" className="mt-5 flex flex-wrap gap-2">
                  {CITIES.map((c) => (
                    <li
                      key={c}
                      className={`rounded-full border px-4 py-1.5 text-sm ${
                        light
                          ? "border-[#FAF8F5]/20 text-[#FAF8F5]/85"
                          : "border-[#1A1918]/15 text-[#1A1918]/80"
                      }`}
                    >
                      {c}
                    </li>
                  ))}
                </ul>
              </div>
              <div className={`mt-10 flex items-center gap-4 border-t pt-6 ${light ? "border-[#FAF8F5]/10" : "border-[#1A1918]/10"}`}>
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#C85A32] text-[#FAF8F5]">
                  <MapPin size={18} />
                </span>
                <p className={`text-sm leading-relaxed ${light ? "text-[#FAF8F5]/70" : "text-[#6E6A64]"}`}>
                  Sopralluogo gratuito entro 48 ore
                  <br />
                  in un raggio di 60 km da Osimo.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
